import script from "./DataTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableItem.vue?vue&type=script&setup=true&lang=js"

import "./DataTableItem.vue?vue&type=style&index=0&id=61e3bf7b&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/wk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e3bf7b"]])

export default __exports__